import { FormControl, FormLabel, Input } from '@chakra-ui/react'
import React, { ChangeEvent, useMemo } from 'react'
import ButtonCopy from 'v2/components/shared/ButtonCopy'
import { Col } from 'v2/components/shared/Col'
import { Row } from 'v2/components/shared/Row'
import { FieldProps } from '../..'

interface TextFieldProps extends FieldProps<'text', string, string> {}

const TextField: React.FC<TextFieldProps> = ({
  infos,
  value,
  onChange,
  mask,
  isReadonly,
  maxLength
}) => {
  const isUndefined = value === undefined
  const isNull = value === null
  const fieldValue = useMemo(() => {
    if (isUndefined && isReadonly) {
      return 'Não definido'
    }

    if (isUndefined || isNull) {
      return ''
    }

    return value
  }, [value, isUndefined, isNull, isReadonly])

  return (
    <FormControl
      minH={'100%'}
      display={'flex'}
      flexDir={'column'}
      fontFamily={'heading'}
    >
      <Col mb={1}>
        <FormLabel fontWeight={'bold'} mb={0}>
          {infos.label}
        </FormLabel>
        <FormLabel color={'GrayText'} mb={0} fontSize={'xs'}>
          {infos.description}
        </FormLabel>
      </Col>
      <Row pos={'relative'} alignItems={'center'} role='group' mt={'auto'}>
        <Input
          rounded={'sm'}
          maxLength={maxLength}
          value={`${fieldValue}`}
          placeholder={infos.placeholder}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value
            if (infos.mask) {
              onChange?.(infos.mask(value))
            } else {
              onChange?.(value)
            }
          }}
          readOnly={isReadonly}
          variant={'filled'}
          border={'1px solid #818c96'}
          backgroundColor={'white'}
          fontStyle={isUndefined ? 'italic' : 'normal'}
          onBlur={() => infos.onBlur?.()}
          color={isUndefined ? 'gray.500' : 'inherit'}
          _focus={
            isReadonly
              ? {}
              : {
                  bg: 'white'
                }
          }
        />
        <ButtonCopy value={value || ''} />
      </Row>
    </FormControl>
  )
}

export default TextField
